(function () {
  window.__ecwGiftConfig = window.__ecwGiftConfig || {};
  window.__ecwLastBundleCartAdd = 0;

  var MIN_GIFT_QTY = 3;
  var GIFT_REMOVAL_GRACE_MS = 5000;
  var DEFAULT_PAD_HANDLES = [
    'compresa-reutilizable',
    'compresa-reutilizable-de-dia-blanco',
    'compresa-reutilizable-noche',
    'compresa-reutilizable-de-noche-blanco',
    'protegeslip-reutilizable',
    'protegeslip-reutilizable-blanco'
  ];

  function isGiftEligibleQty(qty) {
    return (parseInt(qty, 10) || 0) >= MIN_GIFT_QTY;
  }

  function getGiftProps() {
    var cfg = window.__ecwGiftConfig;
    return {
      key: cfg.giftPropertyKey || 'Bolsita impermeable',
      value: cfg.giftPropertyValue || 'Gratis'
    };
  }

  function getFormGiftField(form, name) {
    if (!form) return '';
    var el = form.querySelector('[name="' + name + '"]');
    if (el && el.value != null && String(el.value).trim() !== '') return String(el.value).trim();
    if (form.id) {
      el = document.querySelector('[name="' + name + '"][form="' + form.id + '"]');
      if (el && el.value != null && String(el.value).trim() !== '') return String(el.value).trim();
    }
    return '';
  }

  function collectFormProperties(formData) {
    var props = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) props[match[1]] = value;
    });
    return props;
  }

  function getGiftColorForForm(form) {
    var color = getFormGiftField(form, 'properties[_bundle_gift_color]').toLowerCase();
    if (color === 'white' || color === 'black') return color;
    return 'black';
  }

  function getGiftVariantIdForColor(color) {
    var cfg = window.__ecwGiftConfig || {};
    var id = color === 'white' ? cfg.whiteVariantId : cfg.blackVariantId;
    id = parseInt(id, 10);
    return id > 0 ? id : null;
  }

  function getGiftHandleForColor(color) {
    var cfg = window.__ecwGiftConfig;
    if (color === 'white') return cfg.whiteHandle || 'bolsita-impermeable-de-regalo-blanco';
    return cfg.blackHandle || 'bolsita-impermeable-de-regalo-negro';
  }

  function pickAvailableVariantId(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i += 1) {
      var variant = product.variants[i];
      if (variant && variant.available === true && variant.id) return variant.id;
    }
    return null;
  }

  function rememberGiftVariant(color, variantId) {
    if (!window.__ecwGiftConfig) window.__ecwGiftConfig = {};
    if (color === 'white') window.__ecwGiftConfig.whiteVariantId = variantId || null;
    else window.__ecwGiftConfig.blackVariantId = variantId || null;
  }

  function cartAddFailed(res) {
    if (!res) return true;
    if (res.items || res.key || res.variant_id || res.product_id || res.id) {
      return typeof res.status === 'number' && res.status >= 400;
    }
    return typeof res.status === 'number' && res.status >= 400;
  }

  function fetchJsonTimeout(url, opts, ms) {
    return Promise.race([
      fetch(url, opts).then(function (r) { return r.json(); }),
      new Promise(function (_, reject) {
        setTimeout(function () { reject(new Error('timeout')); }, ms || 4000);
      })
    ]);
  }

  async function postCartItems(items, withSections) {
    var payload = { items: items };
    if (withSections) {
      payload.sections = ['cart-drawer', 'cart-icon-bubble'];
      payload.sections_url = window.location.pathname;
    }
    return fetchJsonTimeout((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }, 8000);
  }

  function giftAddSucceeded(res) {
    if (!res || typeof res !== 'object') return false;
    if (typeof res.status === 'number' && res.status >= 400) return false;
    if (res.description && /sold out|agotad|ausverkauft|nicht verf/i.test(String(res.description))) return false;
    return !!(res.items && res.items.length) || !!res.key || !!res.variant_id;
  }

  async function cartHasGift() {
    var cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return window.__ecwIsBundleGiftItem && window.__ecwIsBundleGiftItem(item);
    });
  }

  async function resolveGiftVariantId(color) {
    var handle = getGiftHandleForColor(color);
    if (!handle) return null;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    try {
      var response = await fetch(root + 'products/' + handle + '.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) {
        rememberGiftVariant(color, null);
        return null;
      }
      var product = await response.json();
      var variantId = pickAvailableVariantId(product);
      rememberGiftVariant(color, variantId);
      return variantId || null;
    } catch (err) {
      return null;
    }
  }

  async function resolveDesiredGift(preferredColor) {
    var first = preferredColor === 'white' ? 'white' : 'black';
    var second = first === 'white' ? 'black' : 'white';
    var firstId = await resolveGiftVariantId(first);
    if (firstId) return { color: first, variantId: firstId, handle: getGiftHandleForColor(first) };
    var secondId = await resolveGiftVariantId(second);
    if (secondId) return { color: second, variantId: secondId, handle: getGiftHandleForColor(second) };
    return null;
  }

  async function postGiftVariant(giftVariantId, properties) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(giftVariantId),
          quantity: 1,
          properties: properties || {}
        }]
      })
    }).then(function (r) { return r.json(); });
  }

  async function addGiftByVariantId(giftVariantId) {
    if (!giftVariantId) return false;
    if (await cartHasGift()) return true;
    var giftProps = getGiftProps();
    var giftLineProps = { '_bundle_gift_auto': 'true' };
    giftLineProps[giftProps.key] = giftProps.value;
    try {
      var giftRes = await postGiftVariant(giftVariantId, giftLineProps);
      if (giftAddSucceeded(giftRes) && await cartHasGift()) return true;
      if (await cartHasGift()) return true;
      giftRes = await postGiftVariant(giftVariantId, {});
      if (giftAddSucceeded(giftRes)) return true;
      return cartHasGift();
    } catch (err) {
      console.error('Bolsita de regalo no agregada:', err);
      return false;
    }
  }

  async function tryAddGiftBag(color) {
    try {
      if (await cartHasGift()) return true;
      var desired = await resolveDesiredGift(color || 'black');
      if (!desired) return false;
      return addGiftByVariantId(desired.variantId);
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  window.__ecwAddGiftBagAfterProduct = async function (form) {
    if (!isPadHandle(resolveAddedHandle(form))) return false;
    var shouldAdd = typeof window.__ecwShouldAddBundleGift === 'function'
      ? window.__ecwShouldAddBundleGift(form)
      : false;
    if (!shouldAdd) return false;
    window.__ecwGraceGiftRemoval = true;
    window.__ecwMarkCartAdd();
    return tryAddGiftBag(getGiftColorForForm(form) || 'black');
  };

  function inferFreeQtyFromPaid(paidQty) {
    var paid = parseInt(paidQty, 10) || 0;
    if (paid === 2) return 1;
    if (paid === 4) return 2;
    if (paid === 6) return 3;
    return 0;
  }

  function getCheckedBundleRadio() {
    return document.querySelector('.bundle-choices--free-units .bundle-choices__radio:checked')
      || document.querySelector('.bundle-choices__radio:checked');
  }

  function receiveQtyFromRadio(radio) {
    if (!radio) return 0;
    var paid = parseInt(radio.getAttribute('data-paid-qty') || radio.getAttribute('data-qty'), 10) || 0;
    var free = parseInt(radio.getAttribute('data-free-qty'), 10) || 0;
    var receive = parseInt(radio.getAttribute('data-receive-qty'), 10) || 0;
    var rootEl = radio.closest('.bundle-choices');
    if (rootEl && rootEl.classList.contains('bundle-choices--free-units')) {
      return receive || (paid + free) || paid;
    }
    return paid || receive;
  }

  window.__ecwGetAddQty = function (form) {
    var radio = form && form.querySelector
      ? form.querySelector('.bundle-choices__radio:checked')
      : null;
    if (!radio) radio = getCheckedBundleRadio();
    if (radio) {
      var rootEl = radio.closest('.bundle-choices');
      if (rootEl && rootEl.classList.contains('bundle-choices--free-units')) {
        var paid = parseInt(radio.getAttribute('data-paid-qty') || radio.getAttribute('data-qty'), 10) || 0;
        var free = parseInt(radio.getAttribute('data-free-qty'), 10) || 0;
        var receive = parseInt(radio.getAttribute('data-receive-qty'), 10) || 0;
        var addQty = receive > 0 ? receive : (paid + free);
        return addQty > 0 ? addQty : 1;
      }
      var fromRadio = receiveQtyFromRadio(radio);
      if (fromRadio > 0) return fromRadio;
    }

    var promo = window.__ecwCurrentPromo;
    if (promo && promo.enabled) {
      var paidPromo = parseInt(promo.paidQty, 10) || 0;
      var freePromo = parseInt(promo.freeQty, 10) || 0;
      if (paidPromo + freePromo > 0) return paidPromo + freePromo;
    }

    if (form) {
      var hidden = form.querySelector('input.bundle-qty[name="quantity"]');
      var hiddenQty = parseInt(hidden && hidden.value, 10) || 0;
      if (hiddenQty > 0) return hiddenQty;
    }

    return parseInt((form && form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1;
  };

  function isFreeUnitsPromoEnabled() {
    if (window.__ecwCurrentPromo && window.__ecwCurrentPromo.enabled) return true;
    if (window.__ecwPromoType === 'free_units') return true;
    return false;
  }

  function getCurrentProductHandle() {
    var match = (window.location.pathname || '').match(/\/products\/([^/?#]+)/);
    if (match) return decodeURIComponent(match[1]).toLowerCase();
    var handleEl = document.querySelector('product-form[data-product-handle]');
    if (handleEl && handleEl.getAttribute('data-product-handle')) {
      return String(handleEl.getAttribute('data-product-handle')).toLowerCase();
    }
    return '';
  }

  function isPadHandle(handle) {
    var h = String(handle || '').toLowerCase().trim();
    if (!h) return false;
    var cfg = window.__ecwGiftConfig || {};
    var padHandles = cfg.padHandles || DEFAULT_PAD_HANDLES;
    if (padHandles && padHandles.indexOf && padHandles.indexOf(h) !== -1 && h.indexOf('compresa') !== -1) return true;
    if (padHandles && padHandles.indexOf && padHandles.indexOf(h) !== -1 && h.indexOf('protegeslip') !== -1) return true;
    return h.indexOf('compresa') !== -1 || h.indexOf('protegeslip') !== -1;
  }

  function formProductHandle(form) {
    if (!form) return '';
    var root = form.closest ? form.closest('product-form') : null;
    var handle = root && root.getAttribute('data-product-handle');
    return handle ? String(handle).toLowerCase() : '';
  }

  function resolveAddedHandle(form) {
    return formProductHandle(form) || getCurrentProductHandle();
  }

  function isCurrentProductPad() {
    return isPadHandle(getCurrentProductHandle());
  }

  window.__ecwShouldAddBundleGift = function (form) {
    if (!form || !isPadHandle(resolveAddedHandle(form))) return false;
    if (getFormGiftField(form, 'properties[_bundle_gift_eligible]') !== 'true') return false;
    var packQty = parseInt(getFormGiftField(form, 'properties[_bundle_gift_qty]') || '0', 10);
    if (!packQty) packQty = window.__ecwGetAddQty(form);
    return isGiftEligibleQty(packQty);
  };

  window.__ecwShouldAddPromoItems = function () {
    return false;
  };

  window.__ecwMarkCartAdd = function () {
    window.__ecwLastBundleCartAdd = Date.now();
  };

  window.__ecwRecentlyAddedBundle = function () {
    return Date.now() - (window.__ecwLastBundleCartAdd || 0) < GIFT_REMOVAL_GRACE_MS;
  };

  function cartSectionsLookEmpty(html) {
    if (!html) return true;
    if (html.indexOf('cart-item') !== -1 || html.indexOf('CartItem-') !== -1 || html.indexOf('CartDrawer-Item') !== -1) return false;
    return html.indexOf('drawer__inner-empty') !== -1;
  }

  window.__ecwFetchCartSections = async function (cartComponent) {
    if (!cartComponent || typeof cartComponent.getSectionsToRender !== 'function') return {};
    var ids = cartComponent.getSectionsToRender().map(function (section) {
      return section.id;
    });
    if (!ids.length) return {};
    var url = window.location.pathname + '?sections=' + ids.join(',');
    var response = await fetch(url, { credentials: 'same-origin' });
    return response.json();
  };

  window.__ecwRefreshCartDrawer = async function () {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var response = await fetch(cartUrl + '?section_id=cart-drawer&ecw=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    var htmlText = await response.text();
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');

    [
      { live: 'cart-drawer-items', source: 'cart-drawer-items' },
      { live: '.cart-drawer__footer', source: '.cart-drawer__footer' },
      { live: '#CartDrawer .quantity_counter', source: '#CartDrawer .quantity_counter' },
      { live: '#CartDrawer .drawer__progress-bar', source: '#CartDrawer .drawer__progress-bar' },
      { live: '#CartDrawer .drawer__heading', source: '#CartDrawer .drawer__heading' }
    ].forEach(function (pair) {
      var target = document.querySelector(pair.live);
      var source = doc.querySelector(pair.source);
      if (target && source) target.replaceWith(source);
    });

    var newDrawer = doc.querySelector('cart-drawer');
    var currentDrawer = document.querySelector('cart-drawer');
    if (newDrawer && currentDrawer) {
      currentDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
    }

    var emptyEl = document.querySelector('.drawer__inner-empty');
    if (emptyEl && newDrawer && !newDrawer.classList.contains('is-empty')) {
      emptyEl.remove();
    }
    if (currentDrawer && newDrawer && !newDrawer.classList.contains('is-empty')) {
      currentDrawer.classList.remove('is-empty');
    }

    var bubbleData = await fetch(window.location.pathname + '?sections=cart-icon-bubble', {
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).catch(function () { return {}; });

    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (bubbleEl && bubbleData['cart-icon-bubble']) {
      var parsed = new DOMParser().parseFromString(bubbleData['cart-icon-bubble'], 'text/html');
      var inner = parsed.querySelector('.shopify-section');
      if (inner) bubbleEl.innerHTML = inner.innerHTML;
    }

    if (currentDrawer && typeof currentDrawer.open === 'function' && currentDrawer.classList.contains('active')) {
      var overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', currentDrawer.close.bind(currentDrawer));
    }
  };

  window.__ecwEnsureFreeUnitsForCart = async function () {
    return false;
  };

  window.__ecwAddPromoItems = async function (form) {
    return window.__ecwAddBundleProductAndGift(form);
  };

  window.__ecwAddBundleProductAndGift = async function () {
    return null;
  };

  function isBundleGiftHandle(handle) {
    var cfg = window.__ecwGiftConfig || {};
    return handle === (cfg.whiteHandle || 'bolsita-impermeable-de-regalo-blanco') ||
      handle === (cfg.blackHandle || 'bolsita-impermeable-de-regalo-negro');
  }

  function itemProductHandle(item) {
    var handle = String(item && item.handle || '').toLowerCase();
    if (handle) return handle;
    var match = String(item && item.url || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function isPadCartItem(item) {
    if (!item) return false;
    return isPadHandle(itemProductHandle(item));
  }

  window.__ecwIsBundleGiftItem = function (item) {
    if (!item) return false;
    if (isBundleGiftHandle(item.handle)) return true;
    if (item.properties && item.properties._bundle_gift_auto != null &&
      String(item.properties._bundle_gift_auto).trim() !== '') return true;
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    return (parseInt(item.final_price, 10) || 0) === 0 &&
      title.indexOf('bolsita') !== -1;
  };

  function getPadLineItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) {
      return item && !window.__ecwIsBundleGiftItem(item) && isPadCartItem(item);
    });
  }

  function getPadItemEffectiveQty(item) {
    return parseInt(item && item.quantity, 10) || 0;
  }

  function getTotalPadQty(cart) {
    return getPadLineItems(cart).reduce(function (total, item) {
      return total + getPadItemEffectiveQty(item);
    }, 0);
  }

  function getGiftColorForPadItem(item) {
    var color = 'black';
    var handle = (item.handle || '').toLowerCase();
    var colorProp = item.properties && item.properties._bundle_gift_color
      ? String(item.properties._bundle_gift_color).toLowerCase()
      : '';
    if (colorProp === 'white' || colorProp === 'black') {
      color = colorProp;
    } else if (handle.indexOf('white') !== -1 || handle.indexOf('blanco') !== -1) {
      color = 'white';
    }
    return color;
  }

  window.__ecwGetPadItemEffectiveQty = getPadItemEffectiveQty;
  window.__ecwGetTotalPadQty = getTotalPadQty;

  window.__ecwIsCartGiftEligible = function (cart) {
    return getTotalPadQty(cart) >= MIN_GIFT_QTY;
  };

  window.__ecwHasEligiblePackLine = function (cart) {
    return window.__ecwIsCartGiftEligible(cart);
  };

  window.__ecwRemoveOrphanFreeUnits = function (cart) {
    if (!cart || !cart.items) return {};
    var paidByVariant = {};
    cart.items.forEach(function (item) {
      var isFree = item.properties && String(item.properties._ecowoman_free || '') === '1';
      if (isFree) return;
      var id = item.variant_id || item.id;
      paidByVariant[id] = (paidByVariant[id] || 0) + (parseInt(item.quantity, 10) || 0);
    });

    var updates = {};
    cart.items.forEach(function (item) {
      var isFree = item.properties && String(item.properties._ecowoman_free || '') === '1';
      if (!isFree) return;
      var id = item.variant_id || item.id;
      if (!paidByVariant[id]) updates[item.key] = 0;
    });
    return updates;
  };

  window.__ecwRemoveAllGiftsFromCart = async function (cartOptional) {
    var cart = cartOptional;
    if (!cart || !cart.items) {
      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    var updates = window.__ecwRemoveOrphanFreeUnits(cart) || {};
    cart.items.forEach(function (item) {
      if (window.__ecwIsBundleGiftItem(item)) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return false;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    });

    return true;
  };

  window.__ecwRemoveOrphanGifts = async function (cartOptional) {
    var earlyCart = cartOptional;
    if (!earlyCart || !earlyCart.items) {
      earlyCart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }
    if (getTotalPadQty(earlyCart) <= 0) {
      return window.__ecwRemoveAllGiftsFromCart(earlyCart);
    }
    if (window.__ecwGraceGiftRemoval && window.__ecwRecentlyAddedBundle && window.__ecwRecentlyAddedBundle()) return false;
    var cart = cartOptional;
    if (!cart || !cart.items) {
      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }
    if (window.__ecwIsCartGiftEligible(cart)) return false;
    var removed = await window.__ecwRemoveAllGiftsFromCart(cart);
    if (removed && typeof window.__ecwRefreshCartDrawer === 'function') {
      await window.__ecwRefreshCartDrawer();
    }
    return removed;
  };

  window.__ecwSyncGiftBagForCart = async function (opts) {
    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    var totalPads = getTotalPadQty(cart);

    if (totalPads < MIN_GIFT_QTY) {
      if (totalPads > 0 && window.__ecwGraceGiftRemoval && window.__ecwRecentlyAddedBundle && window.__ecwRecentlyAddedBundle()) return false;
      return window.__ecwRemoveAllGiftsFromCart(cart);
    }

    var padItems = getPadLineItems(cart);
    if (!padItems.length) return false;

    padItems.sort(function (a, b) {
      return (parseInt(b.quantity, 10) || 0) - (parseInt(a.quantity, 10) || 0);
    });

    var preferred = getGiftColorForPadItem(padItems[0]);
    var desired = await resolveDesiredGift(preferred);
    if (!desired) return false;
    var color = desired.color;
    var desiredHandle = desired.handle;
    var desiredVariantId = desired.variantId;

    var giftItems = cart.items.filter(function (item) {
      return window.__ecwIsBundleGiftItem(item);
    });
    var correctGift = giftItems.filter(function (item) {
      return item.handle === desiredHandle;
    });
    var wrongGifts = giftItems.filter(function (item) {
      return item.handle !== desiredHandle;
    });

    var updates = {};
    wrongGifts.forEach(function (item) {
      updates[item.key] = 0;
    });

    if (correctGift.length > 1) {
      var kept = false;
      correctGift.forEach(function (item) {
        if (!kept) {
          if ((parseInt(item.quantity, 10) || 0) !== 1) updates[item.key] = 1;
          kept = true;
        } else {
          updates[item.key] = 0;
        }
      });
    } else if (correctGift.length === 1) {
      var onlyGift = correctGift[0];
      if ((parseInt(onlyGift.quantity, 10) || 0) !== 1) {
        updates[onlyGift.key] = 1;
      }
    }

    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      });
    }

    if (correctGift.length === 0) {
      var addedGift = await tryAddGiftBag(color);
      if (!addedGift) return false;
    }

    if (Object.keys(updates).length > 0 || correctGift.length === 0) {
      if (!(opts && opts.skipRefresh) && typeof window.__ecwRefreshCartDrawer === 'function') {
        await window.__ecwRefreshCartDrawer();
      }
      return true;
    }

    return false;
  };

  window.__ecwEnsureGiftForCart = async function () {
    return window.__ecwSyncGiftBagForCart();
  };
})();
